// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-onboarding-notification-tab-content {
  display: block;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 16px;
}
.fi-onboarding-notification-tab-content .send-notification-button.mat-mdc-button.mdc-button {
  margin: 0 auto;
  display: block;
  padding: 0 24px;
  background-color: var(--branded-color-01);
  color: var(--branded-color);
  border-radius: 100px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px !important;
  min-height: 40px;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-onboarding/fi-onboarding-builder/fi-onboarding-edit/fi-onboarding-automated-notification-dialog/notification-tab-content/notification-tab-content.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AACJ;AAAI;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,yCAAA;EACA,2BAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;AAER","sourcesContent":[".fi-onboarding-notification-tab-content {\r\n    display: block;\r\n    width: 100%;\r\n    padding-top: 40px;\r\n    padding-bottom: 16px;\r\n    .send-notification-button.mat-mdc-button.mdc-button {\r\n        margin: 0 auto;\r\n        display: block;\r\n        padding: 0 24px;\r\n        background-color: var(--branded-color-01);\r\n        color: var(--branded-color);\r\n        border-radius: 100px;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        line-height: 20px;\r\n        letter-spacing: 0.1px !important;\r\n        min-height: 40px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
